import '../../../../utils/index.mjs';
import { datePickerSharedProps } from './shared.mjs';
import { buildProps } from '../../../../utils/vue/props/runtime.mjs';
const date = datePickerSharedProps.date,
  disabledDate = datePickerSharedProps.disabledDate,
  parsedValue = datePickerSharedProps.parsedValue;
const basicYearTableProps = buildProps({
  date,
  disabledDate,
  parsedValue
});
export { basicYearTableProps };